import i18next from 'i18next'

i18next.addResourceBundle('en', 'notification', {
    message: 'Message',
    notify_all_active_users: 'Notify all active users',
    notify: 'Notify',
    clear: 'Clear',
})
